<!-- note that css is not being picked up by css file, hard coded in line styles -->
<div class="container">
        <div class="text-center main-text" style="font-size: 90px; font-weight: bold; color: red;">404</div>
        <div class="text-center not-found-text" style="font-size: 30px;"><div>Whoops! Sorry, but it looks like the page you are looking for does not exist.</div></div>
</div>
